import React from 'react'
import Navbarmenu from './Navbarmenu'
import Topbar from '../headercomponent/Topbar'

const HeaderComponent = () => {
  return (
    <>
   <Topbar/>
    <Navbarmenu/>
    </>
  )
}

export default HeaderComponent 